import clsx from 'clsx';
import { useMemo } from 'react';
import { Rating } from 'react-simple-star-rating';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const GroupedStarReviews = _ref => {
  let {
    className = '',
    reviews,
    onClick = () => undefined
  } = _ref;
  const reviewScore = useMemo(() => parseFloat((reviews.reduce((acc, _ref2) => {
    let {
      score
    } = _ref2;
    return acc += score;
  }, 0) / Math.max(reviews.length, 1)).toFixed(1)), [reviews]);
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles.container, className || ''),
    children: [/*#__PURE__*/_jsx("ul", {
      className: styles.avatars,
      children: reviews.slice(0, 5).reverse().map((review, index) => /*#__PURE__*/_jsx("li", {
        className: styles.avatars__item,
        children: /*#__PURE__*/_jsx("img", {
          loading: "lazy",
          className: styles.avatarImage,
          alt: `Portrait of ${review.authorName}`,
          src: review.avatarUrl
        })
      }, index))
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container__main,
      children: [/*#__PURE__*/_jsx(Rating, {
        size: 18,
        readonly: true,
        allowFraction: true,
        initialValue: reviewScore || 0,
        SVGclassName: styles.star,
        fillColor: "#facc14"
      }), /*#__PURE__*/_jsxs("u", {
        className: styles.button,
        onClick: onClick,
        children: ["Read Review", reviews.length > 1 ? 's' : '', " (", reviews.length, ")"]
      })]
    })]
  });
};

export default GroupedStarReviews;